const ImageSecurityLink = 'https://cdn.o2.cz/mojeo2-product/front-end/digicapture/security_256x256.webp';

export default ImageSecurityLink;
